import type { CombatForecast } from "../combat-forecast.js";
import type { ConflictConfig, ConflictEvent, ConflictIntent, SeatObservation } from "../types.js";

export const HOST_PROTOCOL_VERSION = 1;
export type ArtifactKind = "save" | "replay";

export interface PracticeStart {
  readonly kind: "start";
  readonly protocolVersion: typeof HOST_PROTOCOL_VERSION;
  readonly config: ConflictConfig;
  readonly seatId: string;
  readonly clockSpeed: 1 | 2;
}

export type HostCommand =
  | PracticeStart
  | { readonly kind: "submit"; readonly feedbackId: string; readonly intent: ConflictIntent }
  | { readonly kind: "forecast-combat"; readonly horizonMs: number }
  | { readonly kind: "set-paused"; readonly paused: boolean }
  | { readonly kind: "export-artifact"; readonly artifactKind: ArtifactKind }
  | {
      readonly kind: "import-artifact";
      readonly artifactKind: ArtifactKind;
      readonly value: string;
    }
  | { readonly kind: "exit-replay" }
  | { readonly kind: "dispose" };

export type HostMessage =
  | { readonly kind: "ready"; readonly protocolVersion: typeof HOST_PROTOCOL_VERSION }
  | {
      readonly kind: "observation";
      readonly observation: SeatObservation;
      readonly events: readonly ConflictEvent[];
      readonly workerOwned: true;
    }
  | { readonly kind: "error"; readonly message: string }
  | { readonly kind: "command-result"; readonly feedbackId: string }
  | { readonly kind: "pause-state"; readonly paused: boolean }
  | { readonly kind: "combat-forecast"; readonly forecast: CombatForecast }
  | { readonly kind: "artifact"; readonly artifactKind: ArtifactKind; readonly value: string }
  | { readonly kind: "replay-state"; readonly active: boolean }
  | { readonly kind: "command-error"; readonly message: string; readonly feedbackId?: string }
  | { readonly kind: "disposed" };
